import { computed, ref } from 'vue';

/**
 * Dirty tracking for a settings form backed by reactive state.
 * Call `takeSnapshot()` after the form is (re)initialized from the server;
 * `dirty` compares the current serialized state against that snapshot,
 * and `flashSaved()` re-snapshots + shows the "saved" confirmation briefly.
 */
export function useSettingsForm(source: () => unknown) {
  const snapshot = ref('');
  const saved = ref(false);
  let savedTimeout: ReturnType<typeof setTimeout> | undefined;

  const takeSnapshot = () => {
    snapshot.value = JSON.stringify(source());
  };

  const dirty = computed(() => JSON.stringify(source()) !== snapshot.value);

  const flashSaved = () => {
    takeSnapshot();
    saved.value = true;
    if (savedTimeout) clearTimeout(savedTimeout);
    savedTimeout = setTimeout(() => (saved.value = false), 1800);
  };

  return { dirty, saved, takeSnapshot, flashSaved };
}
